import { useState, useEffect } from "react";
import { CHARGE_CDN } from "../../../../utils/constants";
import { goToPageV2 } from "../../../../utils/common";
import { formatTs } from "../../utils";
import { trackGdp } from "../../../../utils/gio-report";
import { GetDeductInfo } from "../../api";
import { DeductInfo, UserInfo } from "../../types";
import "./index.less";
import ChargeVipLevel from "../charge-vip-level";
import { getReportVipData, entry } from "../../utils";
import AnimatedBgWrapper from "../animated-bg-wrapper";
import { useUserContext } from "../../routes/home/userContext";
import { processOssImage } from "@/utils/image";

interface Props {
  userInfo?: UserInfo | null;
  className?: string;
  simple?: boolean;
}

const UserHeader = (props: Props) => {
  const { className, simple = false, userInfo } = props;
  const [deductInfo, setDeductInfo] = useState<DeductInfo>({});
  const [activeLevel, setActiveLevel] = useState(1);

  const { levelInfo, userInfo: contextUserInfo, userType } = useUserContext();
  const currentUserInfo = userInfo ||
    contextUserInfo || {
      headImg: "",
      nickName: "",
    };

  useEffect(() => {
    getDeductInfo();
  }, []);

  useEffect(() => {
    if (userType && deductInfo?.totalAmt && deductInfo?.totalAmt > 10) {
      trackGdp("P11222", "B018", {
        var_ch: entry,
        userType,
      });
    }
  }, [userType, deductInfo?.totalAmt]);

  const getDeductInfo = async () => {
    try {
      const res = await GetDeductInfo({
        needStartTime: true,
        needPayMoney: true,
      });
      if (res.code === 200) {
        setDeductInfo(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const goToRecord = () => {
    trackGdp("P11222", "B011", {
      var_ch: entry,
      ...getReportVipData(levelInfo),
      userType,
    });
    goToPageV2({
      hash: `/record`,
      pathname: window.location.pathname,
    });
  };

  const getVipDesc = () => {
    /**
     *1. 车主终身会员：固定文案“有效期：终身有效”
     *2. 非车主&是会员：动态文案“有效期：至XXXX-XX-XX”
     *3. 非车主&从未成为过会员：固定文案“当前非小鹏充电会员”
     *4. 非车主&最近90天成为过会员：固定文案“等待您回归的第22天，期待重逢”
     */
    const { invTime = 0, member, memberType } = levelInfo || {};
    const diff = Math.floor((Date.now() - invTime) / 1000 / 3600 / 24) + 1;
    if (memberType === 1) {
      return "有效期：终身有效";
    } else if (memberType === 0) {
      return `有效期：至${formatTs(invTime, "YYYY-MM-DD")}`;
    } else if (!invTime || (!member && diff > 90)) {
      return "当前非小鹏充电会员";
    } else if (!member && diff <= 90) {
      return `等待您回归的第${diff}天，期待重逢`;
    } else {
      return "";
    }
  };

  return (
    <AnimatedBgWrapper level={simple ? 0 : activeLevel}>
      <div className={`user-header ${className || ""}`}>
        {!simple && (
          <div className="user-info">
            <img
              src={processOssImage(
                currentUserInfo?.headImg ||
                  `${CHARGE_CDN}/common/unlogin-avator.png`,
              )}
              className="user-avator"
              alt=""
            />
            <div className="user-name">{currentUserInfo?.nickName || "--"}</div>
            <div className="user-limit-time">{getVipDesc()}</div>
            <span className="divider">|</span>
            <div className="records-wrap" onClick={goToRecord}>
              获得记录
            </div>
            <img
              src={
                "https://s.xiaopeng.com/xp-charge/mini/chargeVip/arrow_right.svg"
              }
              alt=""
              className="arrow-right"
            />
          </div>
        )}
        <ChargeVipLevel
          userLevelInfo={levelInfo}
          deductInfo={deductInfo}
          activeLevel={activeLevel}
          setActiveLevel={setActiveLevel}
          simple={simple}
        />
      </div>
    </AnimatedBgWrapper>
  );
};

export default UserHeader;
